<template>
    <div class="backdrop">
        <div class="modal">
            <h1>{{ modalHeader }}</h1>
            <form action="" class="form">
                <!-- <div class="form__group">
                <input type="text" :disabled="isLocked" v-model="parent" placeholder="" class="form__input" id="criteria_parent" :maxlength="getMaxLength('id')"/>
                <label for="criteria_parent" class="form__label">ID parent</label>
                <span class="form__p">({{ parent.length }}/{{ getMaxLength('id') }})</span>
                </div>  -->
                <div class="form__group">
                <input type="text" :disabled="isLocked" v-model="order_number" placeholder="" class="form__input" id="criteria_order" :maxlength="getMaxLength('order_number')"/>
                <label for="criteria_order" class="form__label">Nr Ordre</label>
                <span class="form__p">({{ order_number.toString().length }}/{{ getMaxLength('order_number') }})</span>
                </div>
                <div class="form__group">
                <input type="text" :disabled="isLocked" v-model="title" placeholder="" class="form__input" id="criteria_title" :maxlength="getMaxLength('title')"/>
                <label for="criteria_title" class="form__label">Titre</label>
                <span class="form__p">({{ title.length }}/{{ getMaxLength('title') }})</span>
                </div>
                <div class="form__group">
                <input type="text" :disabled="isLocked" v-model="reference" placeholder="" class="form__input" id="criteria_reference" :maxlength="getMaxLength('reference_id')" />
                <label for="criteria_reference" class="form__label">Référence</label>
                <span class="form__p">({{ reference.length }}/{{ getMaxLength('reference_id') }})</span>
                </div>
            
                <div class="button-container">
                    <button v-if="!isLocked" @click.prevent="submitForm" class="submit-btn">{{ submitButton }}</button>
                    <button @click.prevent="closeModal" class="cancel-btn">Annuler</button>
                </div>
            </form>
        </div>
    </div>
    <LoadingOverlay v-if="loading"/>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import '../../assets/styles/base.css';
import '../../assets/styles/modal.css';
import LoadingOverlay from '../generic/LoadingOverlay.vue';

export default {
    name: "CriteriaModalCreator",
    data() {
        return {
            /* parent: 0,  */
            order_number: 1,
            title: "",
            reference: "",
            modalHeader: "Création d'un nouveau Critère",
            submitButton: "Créer"
        }
    },
    components:{
        LoadingOverlay
    },
    computed: {
        ...mapState("referential", [
            "activeCriteria", 
            "callerObject", 
            "selectedReferential",
            "maxLength",
            "loading"
        ]),
        ...mapGetters("referential", ["isReferentialLocked", "getMaxLength"]),
        isLocked() {
            return this.isReferentialLocked(this.selectedReferential)
        },
    },
    mounted() {
        //console.log("Modal Creator Open")
        //console.log("callerObject : ", this.callerObject)
        //console.log("active criteria : ", this.activeCriteria)
        if(this.callerObject && Object.keys(this.callerObject).length > 0) {
            this.parent = this.callerObject.id
        } else if (this.activeCriteria && Object.keys(this.activeCriteria).length > 0) {
            this.parent = this.activeCriteria.parent
            this.title = this.activeCriteria.title
            this.reference = this.activeCriteria.reference
            this.order_number = this.activeCriteria.order_number
            this.modalHeader = "Éditer un Critère"
            this.submitButton = "OK"
        } else {
            //console.log("Both callerObject and activeCriteria are empty");
        }
    },
    methods: {
        closeModal() {
            //console.log("closing modal for creating/editing criteria")
            this.$store.commit("referential/toggleCriteriaModal", false)
        },
        async submitForm() {
            //console.log("Just clicking on submit, kinda")
            try {
                this.$store.commit("referential/loadingMutation", true)
                if(this.callerObject && Object.keys(this.callerObject).length > 0) {
                    await this.$store.dispatch("referential/criteriaInsert", {
                        parent_id: parseInt(this.parent),
                        title: this.title,
                        reference: this.reference,
                        order_number: parseInt(this.order_number),
                    })
                } else if (this.activeCriteria && Object.keys(this.activeCriteria).length > 0) {
                    await this.$store.dispatch("referential/criteriaUpdate", {
                        parent_id: parseInt(this.parent),
                        title: this.title,
                        reference: this.reference,
                        order_number: parseInt(this.order_number),
                    })
                }
                this.$store.commit("referential/makeCriteriaActiveMutation", [])
                this.$store.commit("referential/loadingMutation", false)
                this.closeModal()
            } catch (error) {
                console.error("Error submiting criteria", error)
            }
        }
    },
};
</script>

<style scoped> 
</style>